import { combineReducers } from 'redux';
import registrationReducer from './modules/registration';
import titleFeesReducer from './modules/titlefees';
import salesTaxesReducer from './modules/salestaxes';
import mobileHomeReducer from './modules/mobilehome';

const reducers = combineReducers({
  registration: registrationReducer,
  titlefees: titleFeesReducer,
  salestaxes: salesTaxesReducer,
  mobilehome: mobileHomeReducer,
});

export default reducers;



// WEBPACK FOOTER //
// ./src/redux/index.js